import axios from "axios";
import { AcProperties } from "./automationTypes";

export const createACs = async (
  token: string,
  rootspace: string,
  EnvironmentName: string,
  acList: AcProperties[]
) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_PATH}/automation/air-conditioning/picture`,
      {
        rootspace,
        EnvironmentName,
        AirConditioner: acList,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    )
    .then(({ data }) => {
      return data;
    });
};
